export default "/images/reset.png?79d9a73ab9965c4ee15ca5080cec79b4";